import { useState, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Input, ModalBody } from 'reactstrap'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'

/*eslint-disable */

const styles = {
  fileUploadContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  fileUploadInput: {
    position: 'absolute',
    zIndex: 10,
    opacity: 0,
    width: '100%',
    left: 0,
    height: '43px',
    width: '121px',
  },

  uploadButton: {
    background: '#f1f1f1',
    display: 'inline-block',
  },

  fileName: {
    fontSize: '13px',
    marginLeft: '15px',
  },
}

const UploadScorm = (props) => {
  const [originalName, setOriginalName] = useState('No File Chosen')

  const history = useHistory()

  useEffect(() => {
    !props.showUploadScormPage
      ? history.push(`/course/${props.course_id}/edit`)
      : null
    props.onChangeTitleText('')
  }, [])

  useEffect(() => {
    !props.showUploadScormPage
      ? history.push(`/course/${props.course_id}/edit`)
      : null
  }, [props])

  const onChange = (event) => {
    const originalNameSplit = event.target.value.split(/(\\|\/)/g)

    setOriginalName(originalNameSplit[originalNameSplit.length - 1])
  }

  let language = props.language || {}

  return (
    <form onSubmit={props.uploadScorm} id='upload-scorm'>
      <div className='row'>
        <div className='col-md-6 title-container'>
          <Input
            type='text'
            name='title'
            placeholder={language.settings?.title}
            autoFocus
            value={props.title ? props.title : ''}
            onChange={(event) => props.onChangeTitleText(event.target.value)}
            required
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='upload-video-form-row'>
            <div style={styles.fileUploadContainer}>
              <span
                className='btn btn-disabled px-3 py-1 mt-1'
                style={styles.uploadButton}
              >
                {language.general ? language.general.choose_file : null}
              </span>
              <input
                onChange={onChange}
                style={styles.fileUploadInput}
                type='file'
                name='file'
                required
              />
              <span
                className='text-darker h6 pt-1 pb-0 mb-0'
                style={styles.fileName}
              >
                {originalName}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='custom-control custom-checkbox-info mt-2'>
        <input
          className='custom-control-input'
          id='required_content'
          type='checkbox'
          checked={props.requiredContent}
          onChange={props.setRequired}
        />
        <label
          className='custom-control-label '
          htmlFor='required_content'
          style={{ fontSize: '14px', paddingTop: '2px' }}
        >
          {language?.courses?.required}
        </label>
      </div>

      <div className='col px-0 position-absolute bottom-3'>
        <ProgressiveButton
          placeholder={language.courses ? language.courses.upload : null}
          percent={props.uploadScormPercent}
          status={props.uploadScormStatus}
          language={props.language}
          form='upload-scorm'
        />
        <Link to={`/course/${props.course_id}/edit`}>
          <CancelModalButton
            text={language?.general?.cancel}
            customFn={() => props.toggleUploadScormPage(false)}
          />
        </Link>
      </div>
      <div className='pb-6'> </div>
    </form>
  )
}

export default (props) => {
  let language = props.language || {}

  return (
    <CustomModal
      courseId={props.course_id}
      size='lg'
      title={language.courses ? language.courses.add_scorm : null}
    >
      <ModalBody style={{ overflow: 'hidden' }}>
        <UploadScorm {...props} />
      </ModalBody>
    </CustomModal>
  )
}
